import { useState } from 'react';
import { useAuth } from '../hooks/useAuth';

const EyeIcon = ({ off }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    {off ? (<><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/></>)
    : (<><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></>)}
  </svg>
);
const MailIcon = () => (<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>);
const LockIcon = () => (<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>);
const UserIcon = () => (<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>);
const CheckIcon = () => (<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round"><polyline points="20 6 9 17 4 12"/></svg>);



function Field({ icon, label, type = 'text', value, onChange, placeholder, rightEl }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <label style={{ display: 'block', fontSize: 11, fontWeight: 700, letterSpacing: 1.5, color: '#7A7268', textTransform: 'uppercase', marginBottom: 7, fontFamily: "'Barlow Condensed', sans-serif" }}>{label}</label>
      <div style={{ position: 'relative' }}>
        <div style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)', color: '#5A5248', pointerEvents: 'none' }}>{icon}</div>
        <input type={type} value={value} onChange={onChange} placeholder={placeholder} className="input-field"
          onFocus={e => e.target.style.borderColor = '#FF5500'}
          onBlur={e => e.target.style.borderColor = '#2E2924'} />
        {rightEl && <div style={{ position: 'absolute', right: 14, top: '50%', transform: 'translateY(-50%)' }}>{rightEl}</div>}
      </div>
    </div>
  );
}

export default function LoginPage() {
  const { signIn, signUp, resetPassword } = useAuth();
  const [screen, setScreen] = useState('login');
  const [showPass, setShowPass] = useState(false);
  const [showPass2, setShowPass2] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [agreed, setAgreed] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', password: '', password2: '' });
  const set = k => e => { setForm(f => ({ ...f, [k]: e.target.value })); setError(''); };

  const handleSubmit = async () => {
    setError(''); setLoading(true);
    try {
      if (screen === 'login') {
        await signIn(form.email, form.password);
      } else if (screen === 'register') {
        if (form.password !== form.password2) { setError('Passwords do not match'); setLoading(false); return; }
        await signUp(form.email, form.password, form.name);
        setSuccess('Account created! Please check your email to confirm your account before signing in.');
      } else if (screen === 'forgot') {
        await resetPassword(form.email);
        setSuccess('Email sent! Check your inbox.');
      }
    } catch (err) {
      const msgs = {
        'Invalid login credentials': 'Incorrect email or password',
        'User already registered': 'This email is already registered',
        'Password should be at least 6 characters': 'A password deve ter pelo menos 6 caracteres',
      };
      setError(msgs[err.message] || err.message);
    }
    setLoading(false);
  };

  const isValid = screen === 'login'
    ? form.email.includes('@') && form.password.length >= 6
    : screen === 'register'
    ? form.name.length > 1 && form.email.includes('@') && form.password.length >= 6 && form.password === form.password2 && agreed
    : form.email.includes('@');

  return (
    <div style={{ minHeight: '100vh', background: '#111009', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '24px 20px', position: 'relative', overflow: 'hidden' }}>
      <div className="bg-grid"/>
      <div style={{ position: 'absolute', width: 400, height: 400, borderRadius: '50%', background: 'radial-gradient(circle, rgba(255,85,0,0.07) 0%, transparent 70%)', top: -100, left: '50%', transform: 'translateX(-50%)', pointerEvents: 'none' }}/>

      <div className="fu" style={{ width: '100%', maxWidth: 400, background: '#171410', border: '1px solid #2A2520', borderRadius: 20, padding: '36px 28px', position: 'relative', zIndex: 1, boxShadow: '0 24px 80px rgba(0,0,0,0.6)' }}>

        {success ? (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
            <div style={{ fontFamily: "'Barlow Condensed'", fontSize: 24, fontWeight: 800, color: '#F0EBE3', marginBottom: 10 }}>EMAIL SENT</div>
            <p style={{ fontSize: 14, color: '#7A7268', lineHeight: 1.6, marginBottom: 24 }}>{success}</p>
            <button onClick={() => { setScreen('login'); setSuccess(''); }} className="btn-ghost">← Back to login</button>
          </div>
        ) : (
          <>
            {/* Logo */}
            <div style={{ textAlign: 'center', marginBottom: 28 }}>
              <img src="/logo.png" alt="Drumnasium" style={{ width: 140, height: 140, objectFit: 'contain' }}/>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 8 }}>
                <div style={{ flex: 1, height: 1, background: 'linear-gradient(to right, transparent, #2A2520)' }}/>
                <div style={{ width: 5, height: 5, borderRadius: '50%', background: '#FF5500' }}/>
                <div style={{ flex: 1, height: 1, background: 'linear-gradient(to left, transparent, #2A2520)' }}/>
              </div>
            </div>

            {/* Title */}
            <div style={{ marginBottom: 22 }}>
              <h2 style={{ fontFamily: "'Barlow Condensed'", fontSize: 22, fontWeight: 800, color: '#F0EBE3', letterSpacing: 1 }}>
                {screen === 'login' ? 'SIGN IN' : screen === 'register' ? 'CREATE ACCOUNT' : 'RESET PASSWORD'}
              </h2>
              <p style={{ fontSize: 13, color: '#5A5650', marginTop: 4 }}>
                {screen === 'login' ? 'Welcome back. Keep training.' : screen === 'register' ? 'Join Drumnasium. Free to get started.' : 'Enter your email and we will send instructions.'}
              </p>
            </div>

            {/* Error */}
            {error && (
              <div style={{ background: '#2D1010', border: '1px solid #FF444433', borderRadius: 8, padding: '10px 14px', marginBottom: 14, fontSize: 13, color: '#FF8080' }}>
                {error}
              </div>
            )}

            {/* Fields */}
            {screen === 'register' && <Field icon={<UserIcon/>} label="Name" value={form.name} onChange={set('name')} placeholder="Your name"/>}
            <Field icon={<MailIcon/>} label="Email" type="email" value={form.email} onChange={set('email')} placeholder="email@example.com"/>
            {screen !== 'forgot' && (
              <Field icon={<LockIcon/>} label="Password" type={showPass ? 'text' : 'password'} value={form.password} onChange={set('password')} placeholder="Minimum 6 characters"
                rightEl={<button onClick={() => setShowPass(s => !s)} style={{ background: 'transparent', color: '#5A5248', padding: 2 }}><EyeIcon off={showPass}/></button>}/>
            )}
            {screen === 'register' && (
              <>
                <Field icon={<LockIcon/>} label="Confirm Password" type={showPass2 ? 'text' : 'password'} value={form.password2} onChange={set('password2')} placeholder="Repeat your password"
                  rightEl={<button onClick={() => setShowPass2(s => !s)} style={{ background: 'transparent', color: '#5A5248', padding: 2 }}><EyeIcon off={showPass2}/></button>}/>
                {/* Password strength */}
                {form.password.length > 0 && (
                  <div style={{ marginBottom: 14, marginTop: -6 }}>
                    <div style={{ display: 'flex', gap: 4 }}>
                      {[1,2,3].map(i => <div key={i} style={{ flex: 1, height: 3, borderRadius: 2, background: form.password.length >= i*4 ? (form.password.length >= 10 ? '#22C55E' : '#FF5500') : '#2A2520', transition: 'background 0.3s' }}/>)}
                    </div>
                    <div style={{ fontSize: 11, color: '#5A5650', marginTop: 4 }}>{form.password.length < 6 ? 'Weak' : form.password.length < 10 ? 'Fair' : 'Strong'}</div>
                  </div>
                )}
                {/* Terms */}
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 20 }}>
                  <button onClick={() => setAgreed(a => !a)} style={{ width: 20, height: 20, borderRadius: 5, flexShrink: 0, marginTop: 1, background: agreed ? '#FF5500' : 'transparent', border: `2px solid ${agreed ? '#FF5500' : '#3A3530'}`, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff' }}>
                    {agreed && <CheckIcon/>}
                  </button>
                  <span style={{ fontSize: 13, color: '#5A5650', lineHeight: 1.5 }}>I accept the <span style={{ color: '#FF5500' }}>Terms of Use</span> and the <span style={{ color: '#FF5500' }}>Privacy Policy</span></span>
                </div>
              </>
            )}

            {/* Forgot link */}
            {screen === 'login' && (
              <div style={{ textAlign: 'right', marginBottom: 16, marginTop: -6 }}>
                <button onClick={() => setScreen('forgot')} style={{ background: 'transparent', color: '#5A5650', fontSize: 13 }}>Forgot your password?</button>
              </div>
            )}

            {/* Submit */}
            <button onClick={handleSubmit} disabled={!isValid || loading} className="btn-primary" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, marginBottom: 18 }}>
              {loading ? <div style={{ width: 20, height: 20, borderRadius: '50%', border: '2.5px solid rgba(255,255,255,0.3)', borderTopColor: '#fff', animation: 'spin 0.7s linear infinite' }}/> : (screen === 'login' ? 'SIGN IN' : screen === 'register' ? 'CREATE ACCOUNT' : 'SEND EMAIL')}
            </button>

            {/* Switch */}
            <div style={{ textAlign: 'center' }}>
              {screen === 'login' && <span style={{ fontSize: 14, color: '#5A5650' }}>Don't have an account?{' '}<button onClick={() => { setScreen('register'); setError(''); }} style={{ background: 'transparent', color: '#FF5500', fontWeight: 700, fontSize: 14 }}>Create account</button></span>}
              {screen === 'register' && <span style={{ fontSize: 14, color: '#5A5650' }}>Already have an account?{' '}<button onClick={() => { setScreen('login'); setError(''); }} style={{ background: 'transparent', color: '#FF5500', fontWeight: 700, fontSize: 14 }}>Sign in</button></span>}
              {screen === 'forgot' && <button onClick={() => { setScreen('login'); setError(''); }} style={{ background: 'transparent', color: '#FF5500', fontWeight: 700, fontSize: 14 }}>← Back to login</button>}
            </div>

            {screen === 'register' && (
              <div style={{ marginTop: 20, padding: '12px 14px', background: '#1C1916', borderRadius: 8, border: '1px solid #2A2520', display: 'flex', gap: 10, alignItems: 'flex-start' }}>
                <span style={{ fontSize: 18 }}>🥁</span>
                <span style={{ fontSize: 12, color: '#5A5650', lineHeight: 1.5 }}>Start free with access to base exercises. You can upgrade to <span style={{ color: '#FF5500', fontWeight: 700 }}>Pro</span> whenever you want.</span>
              </div>
            )}
          </>
        )}
      </div>
      <div style={{ marginTop: 24, fontSize: 11, color: '#2E2A26', letterSpacing: 2, fontWeight: 600, fontFamily: "'Barlow Condensed'" }}>DRUMNASIUM © 2025 · PERCUSSION TRAINING</div>
    </div>
  );
}
